const palette = {
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.60)",
    disabled: "rgba(0, 0, 0, 0.38)",
  },
  primary: {
    main: "rgba(0, 87, 178, 1)",
    dark: "rgba(30, 136, 229, 1)",
    light: "rgba(229, 247, 253, 1)",
  },
  secondary: {
    main: "rgba(203, 27, 185, 1)",
    dark: "rgba(177, 0, 169, 1)",
    light: "rgba(227, 138, 214, 1)",
  },
  error: {
    main: "rgba(211, 47, 47, 1)",
    dark: "rgba(198, 40, 40, 1)",
    light: "rgba(238, 97, 97, 1)",
  },
  warning: {
    main: "rgba(239, 108, 0, 1)",
    dark: "rgba(239, 108, 0, 1)",
    light: "rgba(255, 152, 0, 1)",
  },
  info: {
    main: "rgba(1, 136, 209, 1)",
    dark: "rgba(1, 87, 155, 1)",
    light: "rgba(41, 182, 246, 1)",
  },
  success: {
    main: "rgba(46, 125, 50, 1)",
    dark: "rgba(27, 94, 32, 1)",
    light: "rgba(76, 175, 80, 1)",
  },
  action: {
    active: "rgba(0, 0, 0, 0.56)",
    hover: "rgba(0, 0, 0, 0.04)",
    selected: "rgba(0, 0, 0, 0.08)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    focus: "rgba(0, 0, 0, 0.12)",
    disabled: "rgba(0, 0, 0, 0.38)",
  },
  background: {
    default: "rgba(255, 255, 255, 1)",
  },
};

export default palette;
